<mat-card fxLayoutGap="15px">
  <div fxLayout="column" fxFlex>
    <mat-card-content>
      <!-- boutons de passage des status de la demande -->
      <mat-card-actions fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutGap="15px" fxFlex="1 1 auto">
          <button mat-raised-button
                  [class]="loaningSvc.getClassColorBtnChip(nextState?.nextStatus)"
                  [matTooltip]="nextState?.tooltip"
                  (click)="changeState(nextState?.nextStatus)"
                  data-cy="btn-take-charge-consult-state">
            {{nextState?.btnText}}
          </button>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
          <button mat-icon-button class="icon-display"
                  (click)="exportPdfConsultation()"
                  [matTooltip]="'Télécharger la demande en PDF'" data-cy="btn-take-charge-dwld-pdf">
            <mat-icon class="large-icon">picture_as_pdf</mat-icon>
          </button>
          <button *ngIf="isGestionnaireOrSuperviseurOrAdmin"
                  mat-icon-button class="icon-display"
                  (click)="uploadScan()"
                  [matTooltip]="'Téléverser des fichiers scans'" data-cy="btn-take-charge-dwld-scans">
            <mat-icon class="large-icon">upload</mat-icon>
          </button>
        </div>
      </mat-card-actions>
    </mat-card-content>
  </div>
</mat-card>
